<template>
  <Modal
    class="cc-modal"
    width="600"
    footer-hide
    v-model="visibility"
    :title="title"
  >
    <div class="content" v-if="data">
      <div class="link-warp">
        <div
          :class="['link-item', { active: current === item.value }]"
          v-for="item in navList"
          :key="item.value"
          @click="onClick(item.value)"
        >
          {{ item.label }}
        </div>
      </div>
      <div class="data-content">
        <Table
          class="domain-table"
          :columns="columns"
          :data="list"
          :loading="tableLoading"
        >
        </Table>
      </div>
    </div>
    <div class="foot">
      <Button
        v-if="title != '关闭隐私保护结果' && title != '开启隐私保护结果'"
        @click="onCancel"
        >前往购物车</Button
      >
      <Button v-else @click="visibility = false">取消</Button>
    </div>
  </Modal>
</template>
<script>
export default {
  name: "renewListModal",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      current: 0,
      navList: [
        {
          value: 0,
          label: "失败列表",
        },
        {
          value: 1,
          label: "成功列表",
        },
      ],
      list: [],
      tableLoading: false,
      columns: [
        {
          type: "index",
          title: "序号",
          width: 80,
          align: "center",
        },
        {
          key: "domainName",
          title: "域名",
          align: "center",
        },
        {
          key: "message",
          title: "结果",
          align: "center",
        },
      ],
    };
  },
  computed: {
    visibility: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val.length > 0) {
          this.onClick(0);
        }
      },
    },
  },
  methods: {
    onCancel() {
      window.location.href = "/shoppingCart";
      this.visibility = false;
    },
    // 切换数据列表
    onClick(val) {
      this.current = val;
      this.tableLoading = true;
      this.list = this.data.filter((o) => o.status === val) || [];
      this.tableLoading = false;
    },
  },
};
</script>
<style lang="less" scoped>
.link-warp {
  padding: 0 15px;
  margin-top: 20px;
  .link-item {
    display: inline-block;
    height: 40px;
    line-height: 40px;
    padding: 0 30px;
    font-size: 16px;
    font-weight: 600;
    color: #4F5867;
    position: relative;
    cursor: pointer;
    transition: all 0.3s;
    // &::before {
    //   content: "";
    //   position: absolute;
    //   bottom: -1px;
    //   width: 0;
    //   height: 2px;
    //   background-color: transparent;
    //   transition: all 0.3s;
    // }
  }
  .link-item.active {
    color: #3992e9;
    font-weight: bold;
    border: 1px solid #759DE6;
    // &::before {
    //   width: 100%;
    //   background-color: #3992e9;
    // }
  }
}
.cc-modal {
  .content {
    min-height: 100px;
    max-height: 500px;
    overflow: hidden;
  }
  .foot {
    border-top: 1px solid #dcdee2;
    padding-top: 16px;
    display: flex;
    justify-content: flex-end;
  }
}
.data-content {
  min-height: 100px;
  max-height: 500px;
  overflow: auto;
}
.row {
  display: flex;
  line-height: 40px;
  .name {
    min-width: 120px;
    text-align: right;
    margin-right: 20px;
  }
}
</style>
